import api from './api';

export default {
  translateErrorMsg(error) {
    return error;
  },
  fetchAll(params) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });

    const url = `/inventory/?${q.join('&')}`;
    return api.get(url);
  },
  fetchAllInventoriesWithBatch(params) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });
    const url = `/inventory/inventoriesWithBatch?${q.join('&')}`;
    return api.get(url);
  },
  fetchWoMovement(params, pateint = '') {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });
    let url = `/inventory/allWoMovement/?${q.join('&')}`;
    if (pateint) {
      url = `/inventory/allWoMovement/${pateint}?${q.join('&')}`;
    }

    return api.get(url);
  },
  fetchSimplify(params) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });

    const url = `/inventory/allSimplify?${q.join('&')}`;
    return api.get(url);
  },
  fetchInventoryByDeliveryOrder(orderId) {
    const url = `/inventory/deliveryOrder/${orderId}/items`
    return api.get(url);
  },
  fetchInventoryForDispense(patient, id, clinicCode) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    const url = `/inventory/dispense/${patient}/${id}?clinicCode=${clinicCode}`;
    return api.get(url);
  },
  fetchExpendables(params) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });

    const url = `/inventory/expendables?${q.join('&')}&fields=name,trademark`;
    return api.get(url);
  },
  fetchInventoryForDispenseProvider(provider, id, clinicCode) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);
    const url = `/inventory/dispenseProvider/${provider}/${id}?clinicCode=${clinicCode}`;
    return api.get(url);
  },
  fetchProcedures(params) {
    const t = `t=${new Date().getTime()}`;
    const q = [];
    q.push(t);

    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });

    const url = `/inventory/procedures?${q.join('&')}&fields=name,price,anaesthesiaCharge`;
    return api.get(url);
  },
  fetchMedicines() {
    const url = '/inventory/medicines';
    return api.get(url);
  },
  fetchPatientBonusInfoForInventory(patient, id) {
    const url = `/inventory/patient-bonus-info/${patient}/${id}`;
    return api.get(url);
  },
  fetchBulkPatientBonusInfoForInventories(patient, inventoryIds) {
    const url = `/inventory/get-bulk-patient-bonus-info/${patient}`;
    return api.post(url, {
      inventoryIds,
    });
  },
  createNew(data) {
    if (data.serviceTags && data.serviceTags.length === 0) {
      delete data.serviceTags;
    }
    return api.post('/inventory', data);
  },
  createNewWithImage(data, imageFile) {
    if (data.serviceTags && data.serviceTags.length === 0) {
      delete data.serviceTags;
    }
    return api.multiPartPost(
      '/inventory',
      data,
      { picture: imageFile },
    );
  },
  updateInventory(id, data) {
    if (data.serviceTags && data.serviceTags.length === 0) {
      delete data.serviceTags;
    }
    return api.put(`/inventory/update/${id}`, data);
  },
  updateInventoryWithImage(id, data, imageFile) {
    if (data.serviceTags && data.serviceTags.length === 0) {
      delete data.serviceTags;
    }
    console.log('updating inventory data ', data);
    return api.multiPartPut(
      `/inventory/update/${id}`,
      data,
      { picture: imageFile },
    );
  },
  updateBulkInventory(data) {
    return api.put('/inventory/updateBulk', data);
  },
  delete(id) {
    return api.delete(`/inventory/${id}`);
  },
  deleteBulk(payload) {
    return api.post('/inventory/deleteBulk', payload);
  },
  getInventory(id, fields = '') {
    return api.get(`/inventory/${id}?fields=${fields}`);
  },
  getFreeItemInventory(id) {
    return api.get(`/inventory/freeItem/${id}`);
  },
  getHeldInventory(id, clinicCode) {
    return api.get(`/inventory/${id}/held?clinicCode=${clinicCode}`);
  },
  count(query) {
    const params = Object.keys(query)
      .map(k => `${k}=${query[k]}`)
      .join('&');
    return api.get(`/inventory/count?${params}`);
  },
  selectBatch(inventoryId) {
    return api.get(`/inventory-movement/${inventoryId}/batch`);
  },
  importInventory(data) {
    return api.post('/inventory/import', { items: data });
  },

  getByIds(params) {
    const q = [];
    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });

    const url = `/inventory/ids?${q.join('&')}`;
    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },
  getByIdsWithStock(params) {
    const q = [];
    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });

    const url = `/inventory/idsWithStock?${q.join('&')}`;
    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },
  existsByIds(params) {
    const q = [];
    Object.keys(params).forEach((key) => {
      q.push(`${key}=${params[key]}`);
    });

    const url = `/inventory/exists/ids?${q.join('&')}`;
    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },
};
